import { c as _c } from "react/compiler-runtime";
import './reminder-alert.scss';
import type { ReactNode } from 'react';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
export type ReminderAlertProps = {
  cta: {
    href: string;
    text: ReactNode;
  };
  icon: ReactNode;
  subtitle: ReactNode;
  title: ReactNode;
};

/**
 *  Primive for our reminder alerts.
 * Eventually we might want to expose onClick and make the CTA polymorphic a/button.
 */
export const ReminderAlert: React.FC<ReminderAlertProps> = t0 => {
  const $ = _c(14);
  const {
    cta,
    icon,
    subtitle,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="ReminderAlert__title label-lg md:label-xl label-potent md:label-potent label-neutral-potent mb-snug-md">{title}</div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtitle) {
    t2 = subtitle && <div className="ReminderAlert__subtitle label-md md:label-lg label-moderate label-neutral-mild">{subtitle}</div>;
    $[2] = subtitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="ReminderAlert__titlegroup flex">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== cta.href || $[8] !== cta.text) {
    t4 = <div className="ReminderAlert__button flex flex-row pt-snug-sm md:pt-0 md:pl-comfy-xl md:ml-auto"><ButtonStyle fullWidth={true} variant="secondary"><Link href={cta.href}>{cta.text}</Link></ButtonStyle></div>;
    $[7] = cta.href;
    $[8] = cta.text;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== icon || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className="ReminderAlert flex rounded-lg"><div className="ReminderAlert__section flex p-comfy-sm w-full"><div className="ReminderAlert__body flex gap-comfy-xs items-center w-full">{icon}{t3}{t4}</div></div></div>;
    $[10] = icon;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};